
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/3catinfo/eleccions-municipals-24m-2015/catalunya",
      function () {
        return require("private-next-pages/3catinfo/eleccions-municipals-24m-2015/catalunya/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/3catinfo/eleccions-municipals-24m-2015/catalunya"])
      });
    }
  